import "./index.less";

import React from "react";
import { useTranslate, RemoI18nTFunction } from "@obsbot/remo-i18n";
import { Modal } from "antd";
import { REMO_AGREEMENT_URL } from "@obsbot/remo-server-api";

export interface LoginAgreementProps {
    privacyURL?: string;
    serviceURL?: string;
}

export const LoginAgreement: React.FC<LoginAgreementProps> = ({
    // checked,
    // onChange,
    privacyURL,
    serviceURL,
}) => {
    const t = useTranslate();

    return (
        <div className="login-agreement">
            {/* <Checkbox
                checked={checked}
                onChange={e => {
                    console.log("checked", e.target.checked); // eslint-disable-line no-console
                    onChange(e.target.checked);
                }}
            > */}
            {t("login-page.have-read-and-agree")}{" "}
            <a href={privacyURL} rel="noreferrer" target="_blank">
                {t("login-page.privacy-agreement")}
            </a>{" "}
            {t("login-page.and")}{" "}
            <a href={serviceURL} rel="noreferrer" target="_blank">
                {t("login-page.service-policy")}
            </a>
            {/* </Checkbox> */}
        </div>
    );
};

export interface RequestAgreementParams {
    privacyURL?: string;
    serviceURL?: string;
    t: RemoI18nTFunction;
}
export interface PrivacyAgreementData {
    title: string;
    content: string;
}
export async function getPrivacy(props: {
    privacyURL: string;
    serviceURL: string;
}): Promise<PrivacyAgreementData | undefined> {
    const { privacyURL, serviceURL } = props;
    // 仅中国地区,language为zh的情况下,使用中文隐私协议
    const isZh = serviceURL.indexOf("apprtc.cn") > -1 && privacyURL.indexOf("/en") === -1;
    if (REMO_AGREEMENT_URL) {
        const url = isZh
            ? REMO_AGREEMENT_URL
            : REMO_AGREEMENT_URL.replace("privacy.json", "privacy_en.json");
        const data = await fetch(url).then(response => {
            return response.json();
        });
        if (data.content) {
            data.content = data.content
                .replace(/{{serviceURL}}/g, serviceURL)
                .replace(/{{privacyURL}}/g, privacyURL);
        }
        return data;
    }
    return undefined;
}
export async function requestAgreement({
    t,
    privacyURL,
    serviceURL,
}: RequestAgreementParams): Promise<boolean> {
    if (privacyURL && serviceURL) {
        const data = await getPrivacy({ privacyURL, serviceURL });
        if (data) {
            return await new Promise<boolean>(resolve => {
                Modal.confirm({
                    title: (
                        <div
                            style={{
                                borderBottom: "1px solid #EEEEEE",
                                textAlign: "center",
                                lineHeight: "30px",
                            }}
                        >
                            {data.title}
                        </div>
                    ),
                    icon: null,
                    content: (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: data.content,
                            }}
                        ></div>
                    ),
                    okText: t("cross-region-auth.agree"),
                    cancelText: t("cross-region-auth.disagree"),
                    onOk: () => resolve(true),
                    onCancel: () => resolve(false),
                });
            });
        }
    }
    return new Promise<boolean>(resolve =>
        Modal.confirm({
            content: (
                <div>
                    {t("have-read-and-agree")}{" "}
                    <a href={privacyURL} rel="noreferrer" target="_blank">
                        {t("login-page.privacy-agreement")}
                    </a>{" "}
                    {t("and")}{" "}
                    <a href={serviceURL} rel="noreferrer" target="_blank">
                        {t("login-page.service-policy")}
                    </a>
                </div>
            ),
            icon: null,
            onOk: () => resolve(true),
            onCancel: () => resolve(false),
        }),
    );
}
